import React from 'react';
import { Map } from 'immutable';

import { isChanged, unwrap } from '../../utils/ChangeSpy';

export const PureChangeDetection = Component => {
  /**
   * ChangeDetection decorator.
   *
   * @param props Any extra props will be passed into children.
   * @param props.value {*} Should be Immutable.Map to activate it.
   */
  const PureChangeDetectionWrapped = props => {
    const { checkOn = 'value', ...rest } = props;
    const value = props[checkOn];

    if (!Map.isMap(value)) return <Component {...rest} />;

    const realValue = unwrap(value);
    const changed = isChanged(value);

    const valueProperty = { [checkOn]: realValue };

    return <Component {...rest} changed={changed} {...valueProperty} />;
  };

  PureChangeDetectionWrapped.displayName = `PureChangeDetection(${Component.displayName || Component.name})`;

  return PureChangeDetectionWrapped;
};

const ChangeDetection = Component => {
  /**
   * ChangeDetection decorator.
   *
   * @param props Any extra props will be passed into children.
   * @param props.value {*} Should be Immutable.Map to activate it.
   */
  const ChangeDetectionWrapped = props => {
    const { checkOn = 'value', ...rest } = props;
    const value = props[checkOn];

    if (!Map.isMap(value)) return <Component {...rest} />;

    const realValue = unwrap(value);
    const changed = isChanged(value);

    const valueProperty = { [checkOn]: realValue };

    return <Component {...rest} changed={changed} {...valueProperty} />;
  };

  ChangeDetectionWrapped.displayName = `ChangeDetection(${Component.displayName || Component.name})`;

  return ChangeDetectionWrapped;
};

export default ChangeDetection;

const CheckboxChangeDetection = Component => {
  /**
   * ChangeDetection decorator.
   *
   * @param props Any extra props will be passed into children.
   * @param props.value {*} Should be Immutable.Map to activate it.
   */
  const CheckboxChangeDetectionWrapped = props => {
    const { checked, ...rest } = props;

    if (!Map.isMap(checked)) return <Component {...rest} />;

    const realChecked = unwrap(checked);
    const changed = isChanged(checked);

    return <Component {...props} changed={changed} checked={realChecked} />;
  };

  CheckboxChangeDetectionWrapped.displayName = `CheckboxChangeDetection(${Component.displayName || Component.name})`;

  return CheckboxChangeDetectionWrapped;
};

export { CheckboxChangeDetection };
